var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscussion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#E3B505"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.425 8.89258C25.9331 8.48127 25.3567 8.18329 24.7367 8.01982C24.1167 7.85635 23.4682 7.83139 22.8375 7.9467L19.4932 8.55395C18.7211 8.69574 18.0191 9.09298 17.5 9.68183C16.9795 9.09196 16.2755 8.69463 15.5015 8.55395L12.1625 7.9467C11.5318 7.83128 10.8834 7.85592 10.2632 8.01887C9.64304 8.18182 9.06628 8.47909 8.57375 8.88965C8.08121 9.30021 7.68494 9.81401 7.41298 10.3947C7.14103 10.9754 7.00004 11.6087 7 12.25V21.6938C7.00005 22.7183 7.3596 23.7102 8.01599 24.4968C8.67238 25.2833 9.58397 25.8146 10.5919 25.998L16.0921 26.9981C17.0231 27.1672 17.9769 27.1672 18.9079 26.9981L24.4125 25.998C25.4196 25.8137 26.3302 25.282 26.9857 24.4956C27.6412 23.7091 28.0001 22.7177 28 21.6938V12.25C28.0004 11.609 27.8595 10.9758 27.5872 10.3955C27.315 9.81517 26.9182 9.30202 26.425 8.89258ZM16.625 25.312C16.5515 25.3015 16.478 25.2892 16.4045 25.2761L10.9051 24.2768C10.3003 24.1668 9.75327 23.848 9.35943 23.3759C8.96558 22.9039 8.74991 22.3086 8.75 21.6938V12.25C8.75 11.5538 9.02656 10.8861 9.51884 10.3938C10.0111 9.90151 10.6788 9.62495 11.375 9.62495C11.5335 9.62533 11.6916 9.63968 11.8475 9.66783L15.19 10.2803C15.5922 10.3539 15.9559 10.566 16.218 10.8797C16.4801 11.1935 16.6241 11.5891 16.625 11.998V25.312ZM26.25 21.6938C26.2501 22.3086 26.0344 22.9039 25.6406 23.3759C25.2467 23.848 24.6997 24.1668 24.0949 24.2768L18.5955 25.2761C18.522 25.2892 18.4485 25.3015 18.375 25.312V11.998C18.3749 11.5881 18.5187 11.1913 18.7813 10.8766C19.0438 10.5619 19.4085 10.3493 19.8118 10.276L23.1551 9.66345C23.5338 9.59457 23.9229 9.60977 24.295 9.708C24.6671 9.80623 25.013 9.98507 25.3083 10.2319C25.6036 10.4786 25.8411 10.7873 26.0038 11.1361C26.1665 11.4848 26.2506 11.8651 26.25 12.25V21.6938Z",
    fill: "#131CC9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscussion);
export default __webpack_public_path__ + "static/media/discussion.e8708db26717a3b4ecf3bb0e0ec078e0.svg";
export { ForwardRef as ReactComponent };